export const documentCategoriesSelector = state => state.documentCategories;
